import { Inject, Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder, HubConnectionState, LogLevel } from '@microsoft/signalr';
import { ReplaySubject } from 'rxjs';
import { AlertService } from './alert.service';
import { IUserAuthorization } from '@shared/interfaces/user/user-authorization';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  private url: string;
  private userStopped = false;

  private hubConnection: HubConnection | null = null;
  hubConnection$: ReplaySubject<HubConnection | null> = new ReplaySubject<HubConnection | null>(1);
  
  public userAuthorization?: () => IUserAuthorization;

  constructor(
    @Inject('BASE_URL') baseUrl: string,
    private alertService: AlertService,
  ) {
    this.url = baseUrl + (baseUrl.endsWith('/') ? "" : "/") + "cloud";
  }

  startConnection(): void {
    const hubConnection = new HubConnectionBuilder()
      .withUrl(this.url, { accessTokenFactory: () => this.userAuthorization ? this.userAuthorization().accessToken : "Bearer " })
      .withAutomaticReconnect()
      .configureLogging(LogLevel.None)
      .build();

    hubConnection
      .start()
      .then(() => {
        this.hubConnection = hubConnection;
        this.hubConnection$.next(hubConnection)
      })
      .catch(err => {
        this.hubConnection = null;
        this.hubConnection$.next(null);
      });

      hubConnection.onclose(() => {
            if (!this.userStopped) {
              this.alertService.warning( "alerts.connection-error", 0);
            }
            
            this.userStopped = false;
            this.hubConnection$.next(null);
          });
  }

  isHubConnection(): boolean {
    return this.hubConnection != null && this.hubConnection.state === HubConnectionState.Connected;
  }

  stopConnection() {
    this.userStopped = true;
    this.hubConnection?.stop();
  }
}
